import React, { Component } from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { IPostalCode, Dictionary } from '../../Models';

interface IPostalCodeAndRadiusSelectPanelProps {
    cancelLabel: string;
    onClickSave: (
        postalCode: IPostalCode | null,
        radius: Dictionary<number, string> | null
    ) => void;
    postalCodeLabel: string;
    promiseOptions: (inputValue: string) => any;
    radiusLabel: string;
    radiusOptions: Dictionary<number, string>[];
    saveLabel: string;
}

interface IPostalCodeAndRadiusSelectPanelState {
    selectedPostalCode: IPostalCode | null;
    selectedRadiusKilometer: Dictionary<number, string> | null;
}

export class PostalCodeAndRadiusSelectPanel extends Component<
    IPostalCodeAndRadiusSelectPanelProps,
    IPostalCodeAndRadiusSelectPanelState
> {
    private stateCopy: IPostalCodeAndRadiusSelectPanelState;

    constructor(props: any) {
        super(props);

        this.state = {
            selectedPostalCode: null,
            selectedRadiusKilometer: null,
        };

        this.stateCopy = { ...this.state };
    }

    onSelectPostalCode = (selectedItem: IPostalCode) => {
        this.setState({ selectedPostalCode: selectedItem });
    };

    onSelectRadius = (selectedItem: Dictionary<number, string>) => {
        this.setState({ selectedRadiusKilometer: selectedItem });
    };

    onSave = () => {
        this.stateCopy = { ...this.state };

        if (this.props.onClickSave) {
            this.props.onClickSave(
                this.state.selectedPostalCode,
                this.state.selectedRadiusKilometer
            );
        }
    };

    onCancel = () => {
        this.setState({ ...this.stateCopy });
    };

    render() {
        return (
            <>
                <div
                    className="dropdown-body"
                    onClick={(e) => e.stopPropagation()}
                >
                    <form className="row">
                        <div className="col col-12 col-lg-6">
                            <AsyncSelect
                                menuPortalTarget={null}
                                isClearable
                                value={this.state.selectedPostalCode}
                                placeholder={this.props.postalCodeLabel}
                                loadOptions={this.props.promiseOptions}
                                getOptionLabel={(option: IPostalCode) =>
                                    option.postalCode.toString() +
                                    ' ' +
                                    option.city
                                }
                                getOptionValue={(option: IPostalCode) =>
                                    option.postalCode.toString()
                                }
                                onChange={this.onSelectPostalCode}
                                className="filter-select-container"
                                classNamePrefix="filter-select"
                                area-label={this.props.postalCodeLabel}
                                cacheOptions
                                defaultOptions
                            />
                        </div>
                        <div className="col col-12 col-lg-6">
                            <Select
                                menuPortalTarget={null}
                                isClearable
                                value={this.state.selectedRadiusKilometer}
                                placeholder={this.props.radiusLabel}
                                options={this.props.radiusOptions}
                                onChange={this.onSelectRadius}
                                className="filter-select-container"
                                classNamePrefix="filter-select"
                                area-label={this.props.radiusLabel}
                            />
                        </div>
                    </form>
                </div>
                <div className="dropdown-footer">
                    <a
                        href="#"
                        className="primary"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.onCancel();
                        }}
                    >
                        {this.props.cancelLabel}
                    </a>
                    <a
                        href="#"
                        className="btn-secondary"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.onSave();
                        }}
                    >
                        {this.props.saveLabel}
                    </a>
                </div>
            </>
        );
    }
}
